import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import "src/assets/styles/main.scss"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"
import { EN } from './common/constants';
import common_en from "./translations/en/common.json";
import { AudioProvider } from './components/AudioContext';

i18next.init({
  resources: {
    en: {
      common: common_en
    }
  },
  interpolation: { escapeValue: false },
  lng: window.localStorage.language,
  fallbackLng: EN,
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <I18nextProvider i18n={i18next}>
        <AudioProvider>
          <App />
        </AudioProvider>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
